/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const timestampData = params => formatGivenDate( ( params.data.timestamp ), 'YYYY-MM-DD hh:mm:ss A' );
const weekendProdDateData = params => formatGivenDate( params.data.weekendProdDate, 'YYYY-MM-DD' );

const colDefs = [
    {
        headerName: 'Timestamp',
        sortable: false,
        filter: false,
        width: 148,
        valueGetter: timestampData
    },
    {
        headerName: 'Week End Prod Date',
        sortable: false,
        filter: false,
        width: 150,
        valueGetter: weekendProdDateData
    },
    {
        headerName: 'Forecast Qty',
        children: [
            {
                field: 'oldForecastQty',
                headerName: 'Old',
                sortable: true,
                filter: true,
                width: 70,
                cellRenderer: params => {

                    if ( params.value > 99999 ) return ( <span>Infinite</span> );
                    return ( <span>{params.value}</span> );

                }
            },
            {
                field: 'newForecastQty',
                headerName: 'New',
                sortable: true,
                filter: true,
                width: 70,
                cellRenderer: params => {

                    if ( params.value > 99999 ) return ( <span>Infinite</span> );
                    return ( <span>{params.value}</span> );

                }
            }
        ]
    },
    {
        headerName: 'Max Qty',
        children: [
            {
                field: 'oldMaximumQty',
                headerName: 'Old',
                sortable: true,
                filter: true,
                width: 70,
                cellRenderer: params => {

                    if ( params.value > 99999 ) return ( <span>Infinite</span> );
                    return ( <span>{params.value}</span> );

                }
            },
            {
                field: 'newMaximumQty',
                headerName: 'New',
                sortable: true,
                filter: true,
                width: 70,
                cellRenderer: params => {

                    if ( params.value > 99999 ) return ( <span>Infinite</span> );
                    return ( <span>{params.value}</span> );

                }
            }
        ]
    },
    {
        headerName: 'Flex Qty',
        children: [
            {
                field: 'oldFlexQty',
                headerName: 'Old',
                sortable: true,
                filter: true,
                width: 70,
                cellRenderer: params => {

                    if ( params.value > 99999 ) return ( <span>Infinite</span> );
                    return ( <span>{params.value}</span> );

                }
            },
            {
                field: 'newFlexQty',
                headerName: 'New',
                sortable: true,
                filter: true,
                width: 70,
                cellRenderer: params => {

                    if ( params.value > 99999 ) return ( <span>Infinite</span> );
                    return ( <span>{params.value}</span> );

                }
            }
        ]
    },
    {
        headerName: 'Reserve %',
        children: [
            {
                field: 'oldReservePcnt',
                headerName: 'Old',
                sortable: true,
                filter: true,
                width: 70,
                cellRenderer: params => {

                    if ( params.value > 99999 ) return ( <span>Infinite</span> );
                    return ( <span>{params.value}</span> );

                }
            },
            {
                field: 'newReservePcnt',
                headerName: 'New',
                sortable: true,
                filter: true,
                width: 70,
                cellRenderer: params => {

                    if ( params.value > 99999 ) return ( <span>Infinite</span> );
                    return ( <span>{params.value}</span> );

                }
            }
        ]
    },
    {
        field: 'useridChangeBy',
        headerName: 'Changed By',
        sortable: true,
        filter: true,
        width: 110
    }
];

const ForecastChangeTable = props => (

    <section className="atp-search-result-panel forecast-change-result-panel ">

        <div className="results-message">
            {`Forecast Changes as of ${new Date()}` }
        </div>

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

ForecastChangeTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default ForecastChangeTable;
